export const activeIcon = '#015ca8';
export const fadeIcon = '#e6e7e6';
